// Copie de apps/cinepass/packages/frontend/src/app/use-wide-screen.ts (meme template) : deux apps ne partagent pas de code.
import { useSyncExternalStore } from "react";

/**
 * La barre de Tailwind (`md`) : a partir de 768 px, la frise passe du fil vertical au fil
 * horizontal. Une classe `md:` ne suffit pas quand un element doit changer de PLACE
 * dans l'arbre et pas seulement d'allure : le rendre deux fois (un `hidden`, un `md:inline`) le
 * montrerait deux fois a tout ce qui lit le DOM sans les feuilles de style, lecteur d'ecran compris.
 */
export const WIDE_SCREEN = "(min-width: 768px)";

/** `matchMedia` n'existe pas partout (jsdom) : sans lui, l'ecran est etroit. */
const mediaQuery = (): MediaQueryList | null =>
  typeof window.matchMedia === "function" ? window.matchMedia(WIDE_SCREEN) : null;

function subscribe(onChange: () => void): () => void {
  const query = mediaQuery();
  if (query === null) return () => undefined;
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
}

const isWide = (): boolean => mediaQuery()?.matches ?? false;

/** Vrai quand l'ecran a 768 px de large ou plus. Suit l'ecran quand on elargit la fenetre. */
export function useWideScreen(): boolean {
  return useSyncExternalStore(subscribe, isWide, () => false);
}
